<script setup>
import { inject, computed, ref } from 'vue';
import SddsIconCustom from './SddsIconCustom.vue';
import Tooltip from './Tooltip.vue';
import lightning_bolt from '@/assets/lightning_bolt.svg';
import imagePlaceholder from '../assets/placeholder_cropped.png';

const adobeEvent = inject('adobeEvent');

const props = defineProps(
  {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: 'https://cdn.digitaldesign.scania.com/icons/website_hosted/truck.svg',
    },
    buttonText: {
      type: String,
      default: '',
    },
    personalShopperUrl: {
      type: String,
      default: '',
    },
  },
);

const imageLink = ref(props.imageUrl);

const showCardHeader = computed(() => {
  return true;
});

const sendTracking = () => {
  adobeEvent({
    event: 'goToPersonalShopper',
  });
};

const goToPersonalShopper = () => {
  sendTracking();
  window.open(props.personalShopperUrl, '_blank', 'noopener,noreferrer');
};
</script>
<template>
  <div
    class="card-container"
    @click="goToPersonalShopper()"
  >
    <template v-if="showCardHeader">
      <div
        class="card-header"
      >
        <span
          class="sdds-headline-01"
          style="display: block; color: white;"
        >
          {{ $i18n(title) }}
        </span>
        <span
          class="sdds-headline-05"
          style="display: block; color: white;"
        >
          {{ $i18n(description) }}
        </span>
      </div>
    </template>
    <div
      class="card-top"
    >
      <div class="card-img-container">
        <!-- <img
          :src="imageLink"
          class="card-img"
          alt="Card Image"
        > -->
        <img
          :src="imagePlaceholder"
          class="card-img"
          alt="Card Image"
        >
      </div>
    </div>
    <div
      class="card"
    >
      <div class="card-body">
        <div
          class="price-configure-btn-container"
        >
          <div
            class="configure-btn-container"
          >
            <a
              class="sdds-btn sdds-btn-primary sdds-btn-fullbleed"
              data-dd-action-name="go to personal shopper"
              @click="goToPersonalShopper()"
            >
              {{ $i18n(buttonText) }} <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.958 26.314a1 1 0 1 0 1.415 1.414l9.89-9.89a2.6 2.6 0 0 0 0-3.676l-9.89-9.89a1 1 0 1 0-1.415 1.414L27.273 15H2.976a1 1 0 1 0 0 2h24.296l-9.314 9.314Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.sdds-btn-fullbleed {
  width: fit-content;
}

.card-container {
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  background: linear-gradient(180deg, #041E42 0%, #D8E1EE 100%);
  cursor: pointer;
}
.card-header {
  padding: var(--sdds-spacing-element-32);
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: var(--sdds-spacing-element-8);
  padding-bottom: 0;
}
.card-header .sdds-headline-01 {
  font-size: xx-large;
}

.card-top {
  padding-top: var(--sdds-spacing-element-24);
  display: flex;
  flex-direction: column;
}

.card {
  display: flex;
  flex-direction: column;
}

.card-img-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.card-img-container .card-img {
  width: 55%;
}

.card-body {
  display: flex;
  flex-direction: row-reverse;
  padding: var(--sdds-spacing-element-32);
  padding-top: var(--sdds-spacing-element-16);
}

.configure-btn-container>button,
.configure-btn-container>a {
  display: flex;
  place-content: center;
  align-items: center;
  margin-top: auto;
  color: white;
}

.configure-btn-container>button>svg,
.configure-btn-container>a>svg {
  line-height: 0;
  margin-left: var(--sdds-spacing-element-12);
  height: 6rem;
  width: 6rem;
}

.price-configure-btn-container {
  display: flex;
  justify-content: space-between;
  padding: var(--sdds-spacing-element-12) 0;
}

@media only screen and (max-width: 2100px) {
  .configure-btn-container-width {
    max-width: 250px;
  }
}

@media only screen and (max-width: 1900px) {
  .configure-btn-container-width {
    max-width: 200px;
  }
}

@media only screen and (max-width: 1560px) {
  .card-img-container .card-img {
    width: 60%;
  }
  .card-body {
    padding-top: var(--sdds-spacing-element-32);
  }
}

@media only screen and (max-width: 1366px) {
  .card-img-container .card-img {
    width: 70%;
  }
}

@media only screen and (max-width: 1024px) {
  .active-offers__card-list>* {
    width: 100%;
    margin: unset;
  }
  .card-img-container .card-img {
    width: 60%;
  }
}

@media only screen and (max-width: 900px) {
  .configure-btn-container-width {
    max-width: 180px;
  }
}

@media only screen and (max-width: 800px) {
  .configure-btn-container-width {
    max-width: 160px;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    flex-direction: column;
  }
  .card-body {
    margin-top: var(--sdds-spacing-element-16);
    width: 100%;
  }
  .card-header {
    width: calc(100% - var(--sdds-spacing-layout-32));
  }
  .configure-btn-container-width {
    max-width: unset;
  }
}

@media only screen and (max-width: 600px) {
  .configure-btn-container-width {
    max-width: 180px;
  }
}

@media only screen and (max-width: 350px) {
  .configure-btn-container-width {
    max-width: 160px;
  }
}
</style>
